import { Box, Heading, Link } from '@chakra-ui/react';

interface Props {
  block: {
    type: number;
    label: string;
  };
  content: any;
}

export default function LinkBlock({ block, content }: Props) {
  return (
    <Box>
      <Heading as={'h3'} fontSize={'xl'} mb={2}>
        {block.label}
      </Heading>
      <Box pl={2}>
        <Link href={content} target='_blank' color='blue.fg' textStyle='sm' mr={2}>
          {content}
        </Link>
      </Box>
    </Box>
  );
}
